import { Box, BoxProps, Image } from "@chakra-ui/react";
import PauseIconImage from "./IconButton.svg";

export function PauseSvg({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <Image src={PauseIconImage} alt="pause" />
    </Box>
  );
}
